export const findNodeByValue = (value, nodes) => {
    for (const node of nodes) {
        if (node.value === value) return node; // Match found
        if (node.children) {
            const foundNode = findNodeByValue(value, node.children); // Recursive search
            if (foundNode) return foundNode;
        }
    }
    return null; // No match found
};

export const getAllDescendantNodes = (node) => {
    const descendants = [];
    const collectDescendants = (childNode) => {
        if (childNode.children && childNode.children.length) {
            childNode.children.forEach((child) => {
                descendants.push({ label: child.title, value: child.value });
                collectDescendants(child); // Recursive call
            });
        }
    };
    collectDescendants(node);
    return descendants;
};